<template>
  <div class="gifts_list_item">
    <h2 class="head_title">{{pickPackagesList.title}}</h2>
    <div class="box">
      <ul>
        <li v-for="(item,index) in pickPackagesList.goods_list" :key="index">
          <img :src="item.images" alt />
          <div class="libao_name">
            <article>{{item.goods_name}}</article>
            <span>
              <b>数量：x{{item.num}}</b>
              <!-- <b class="numf">{{item.score}}</b> -->
            </span>
          </div>
        </li>
      </ul>
      <div class="gift_nums">
        数量
        <input
          type="tel"
          v-model="pickNumbers"
          @blur="search"
          @keyup.enter="search"
          @input="search($event)"
        /> 套
      </div>
      <!-- <div class="gift_nums">组合优惠：{{pickZhPrice}}</div> -->
      <div class="gift_nums" style="margin-top: 1px">实付：{{pickPackagesList.score * pickNumbers}}</div>
    </div>
    <div class="gift_btns" @click="imExchange">
      <p>立即提货</p>
    </div>
  </div>

  <!--  <van-list-->
  <!--    class="gift_list"-->
  <!--    v-model="loading"-->
  <!--    :error.sync="error"-->
  <!--    error-text="请求失败，点击重新加载"-->
  <!--    :finished="finished"-->
  <!--    finished-text="没有更多了"-->
  <!--    @load="onLoad"-->
  <!--    :immediate-check="false"-->
  <!--  >-->
  <!--    <div class="gift_list_item" v-for="(items,index) in pckData" :key="index">-->
  <!--      <div class="header">-->
  <!--        <span class="pck_name">{{items.title}}</span>-->
  <!--        <div class="count">-->
  <!--          数量-->
  <!--          <div class="field">-->
  <!--            <van-stepper v-model="pckNumList[index]['pck_num']" integer />-->
  <!--          </div>套-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      <div class="main" v-for="(item,index) in items.goods_list" :key="index">-->
  <!--        <div class="goods_item">-->
  <!--          <div class="goods_image_container">-->
  <!--            <img class="goods_image" :src="item.images?item.images:imgPath+'yj_defatult.png'" />-->
  <!--          </div>-->
  <!--          <div class="goods_info">-->
  <!--            <div class="goods_title van-ellipsis">{{item.goods_name}}</div>-->
  <!--            <div class="goods_detail">-->
  <!--              <div class="goods_num">数量: *{{item.num}}</div>-->
  <!--              <span class="goods_score">{{item.score}}积分</span>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      <div class="exchange">-->
  <!--        <span class="ex_score">合计: {{items.score * pckNumList[index]['pck_num']}}积分</span>-->
  <!--        <div class="ex_btn" @click="imExchange(items,items.id,index)">-->
  <!--          <span class="btn_text">立即兑换</span>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </van-list>-->
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
import '@/assets/css/resetVantUi.scss'
import { add, subtract, multiply } from '../public/floatPublic'

document.body.style.backgroundColor = '#f7f8fa'
export default {
  name: 'giftGoodsList',
  data() {
    return {
      pick_up_id: '', //l利宝id
      pickPackagesList: '', //信息
      pickNumbers: 1, // 数量
      pickZhPrice: '', //组合优惠价格
      pickZhPriceSum: '',
      error: false,
      loading: false,
      finished: false,
      queryObj: {
        page: 1,
        limit: 10,
        pic_up_id: '',
      },
      // 礼包组合数据
      pckData: [],
      // 数据总条数
      count: '',
      // 选择的礼包数量
      num: 1,
      // 礼包数量数组
      pckNumList: [],
      value: 1,
      // 用户积分
      score: '',
      // 兑换节流
      isExchanging: false,
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    //获取礼包详情 06-19
    getgiftInfo() {
      this.http('ClientGoods.getPickPackagesList', {
        page: 1,
        limit: 10,
        pick_up_id: this.pick_up_id,
      }).then((res) => {
        if (res.status == 200) {
          // console.log(res)
          this.pickPackagesList = res.content.list[0]
          console.log(this.pickPackagesList)
          this.goods_lists = res.content.list[0].goods_list
          // console.log(goods_lists)
          var sum = 0
          var goods_lists = res.content.list[0].goods_list
          for (var i = 0; i < goods_lists.length; i++) {
            var sum = sum + multiply(goods_lists[i].score, goods_lists[i].num)
            console.log(sum)
          }
          this.pickZhPriceSum = sum
          // this.pickNumbers  当前数量
          var minus1 = multiply(sum, this.pickNumbers)
          console.log(minus1)
          var minus2 = multiply(this.pickPackagesList.score, this.pickNumbers)
          console.log(minus2)
          this.pickZhPrice = subtract(minus1, minus2)

          // console.log(this.pickZhPrice )
        } else {
          Toast('res.msg')
        }
      })
    },
    // 立即兑换按钮点击
    imExchange() {
      if (this.isExchanging) return
      this.isExchanging = true
      try {
        localStorage.setItem('spec_id', this.pickPackagesList.id)
        localStorage.setItem('package_id', this.pickPackagesList.id)
        localStorage.setItem('type', 'integral_group')
        localStorage.setItem('num', this.pickNumbers)
        this.$router.push({ path: './ConfirmOrder' })
        // 调用兑换接口
        // this.$toast({
        //   message: '您的兑换积分不足',
        //   position: 'middle',
        // })
      } catch (err) {
        this.$toast.fail('兑换失败,请稍后重试')
      } finally {
        this.isExchanging = false
      }
    },
    // 列表加载钩子
    // onLoad() {
    //   this.queryObj.page++
    //   // this.getPckList()
    // },
    // 创建礼包数量数组
    // pckNum(count) {
    //   for (let i = 0; i < count; i++) {
    //     this.pckNumList.push({ pck_num: 1 })
    //   }
    // },

    //监听input数值变化06-19
    search() {
      this.getgiftInfo() // 06-19
    },

    // 获取组合套装商品列表
    // async getPckList() {
    //   try {
    //     let data = await this.http(
    //       'ClientGoods.getPickPackagesList',
    //       this.queryObj
    //     )
    //     if (data.status !== 200 || data.msg !== 'success') {
    //       this.loading = false
    //       this.error = true
    //       this.queryObj.page--
    //       return this.$toast.fail('获取组合套装数据失败,请稍后重试')
    //     }
    //     this.count = data.content.count
    //     //调用函数根据套装数量创建步进器v-model数量的数组
    //     this.pckNum(this.count)
    //     this.pckData = [...this.pckData, ...data.content.list]
    //     if (this.queryObj.limit * this.queryObj.page >= this.count) {
    //       this.loading = false
    //       return (this.finished = true)
    //     }
    //   } catch (err) {
    //     this.error = true
    //     this.loading = false
    //     this.queryObj.page--
    //     return this.$toast.fail('获取组合套装数据失败,请稍后重试')
    //   }
    //   this.loading = false
    // },
  },
  created() {
    console.log(this.$route.query.pic_up_id)

    this.pick_up_id = this.$route.query.pic_up_id
    this.getgiftInfo() // 06-19

    // 获取礼包
    // this.getPckList()
    this.score = this.$route.query.score
  },
  // watch: {
  //   pckNumList: {
  //     handler(val, oldVal) {
  //       val.forEach((item) => {
  //         // 礼包数量禁止输入非法内容
  //         if (item['pck_num'] === '-' || item['pck_num'] <= 0) {
  //           item['pck_num'] = 1
  //         }
  //       })
  //     },
  //     deep: true,
  //   },
  //
  //
  // },
}
</script>
<style scoped>
.gifts_list_item {
  margin: 20px;
}
.box {
  padding-bottom: 200px;
}
.gifts_list_item h2 {
  padding: 0 20px;
  border-radius: 10px;
  font-size: 32px;
  line-height: 88px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  background: #fff;
  margin-bottom: 20px;
}
.gifts_list_item ul {
  display: block;
  border-radius: 10px;
  background: #fff;
}
.gifts_list_item ul li {
  display: flex;
  border-bottom: 1px solid #eee;
  justify-content: space-between;
}
.gifts_list_item ul li img {
  width: 140px;
  height: 140px;
  border-radius: 10px;
  padding: 20px;
}
.gifts_list_item ul li .libao_name {
  width: 560px;
  padding-top: 20px;
}
.libao_name article {
  line-height: 44px;
  max-height: 88px;
  overflow: hidden;
  font-size: 28px;
  padding: 0 20px;
  color: #333;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.libao_name span {
  display: flex;
  padding: 10px 20px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #999;
  justify-content: space-between;
}
.libao_name .numf {
  color: #333;
  font-size: 30px;
}
.gift_nums {
  height: 60px;
  line-height: 60px;
  padding: 20px;
  background: #fff;
  margin-top: 20px;
  font-size: 26px;
  color: #8a8a8a;
  border-radius: 10px;
  text-align: right;
}
.gift_nums input {
  border: 1px solid #ddd;
  width: 120px;
  height: 58px;
  font-size: 30px;
  border-radius: 10px;
  text-align: center;
  line-height: 58px;
  color: #000;
}
.gift_btns {
  width: 100%;
  position: fixed;
  bottom: 0;
  padding-bottom: 50px;
  left: 0;
  /*background: $fff;*/
}
.gift_btns p {
  width: 650px;
  height: 68px;
  line-height: 68px;
  color: #fff;
  border-radius: 40px;
  text-align: center;
  font-size: 26px;
  background: #f0240e;
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
.gift_list {
  padding: 20px;
  .gift_list_item {
    position: relative;
    width: 710px;
    border-radius: 14px;
    background-color: #fff;
    padding-bottom: 30px;
    margin-bottom: 30px;
    .header {
      padding: 0 30px;
      color: $textColor;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 90px;
      border-bottom: 1px solid #efefef;
      .pck_name {
        width: 300px;
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: $textColor;
        line-height: 50px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .count {
        display: flex;
        vertical-align: middle;
        line-height: 54px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: $textColor;
        .field {
          margin: 0 12px;
          height: 52px;
        }
      }
    }
    .main {
      padding: 0 30px;
      .goods_item {
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        border-bottom: 1px solid #eee;
        .goods_image_container {
          width: 140px;
          height: 140px;
          border-radius: 10px;
          overflow: hidden;
          .goods_image {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .goods_info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .goods_title {
            width: 476px;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: $textColor;
          }
          .goods_num {
            width: 130px;
            height: 36px;
            text-align: center;
            background: #f2f2f2;
            border-radius: 8px;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999;
            line-height: 36px;
          }
          .goods_score {
            width: 140px;
            height: 30px;
            font-size: 30px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: $textColor;
            line-height: 30px;
          }
          .goods_detail {
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;
          }
        }
      }
    }
    .exchange {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      margin: 40px 20px 0 0;
      .ex_score {
        height: 45px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 45px;
      }
      .ex_btn {
        width: 200px;
        height: 68px;
        margin-top: 16px;
        text-align: center;
        line-height: 68px;
        background: #f0240e;
        border-radius: 34px;
        .btn_text {
          width: 120px;
          height: 42px;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 42px;
        }
      }
    }
  }
}
</style>